export enum ClientListType {
  MARKUP = 'MARKUP',
  MATCHED = 'MATCHED',
  ORIGINAL = 'ORIGINAL',
}

export enum ClientListStatus {
  NEW = 'NEW',
  MATCHING = 'MATCHING',
  MATCHED = 'MATCHED',
  MARKED = 'MARKED',
  ERROR = 'ERROR',
}
